import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ActualPregnancyI, PerformedPregnancyUser, PregnancyResponseI, PreviousPregnancyI } from "@interfaces/woman/pregnancy";

export const newPregnancySlice = createSlice({
    name: "new-pregnancy",
    initialState: {
        id: "",
        performedByUser: null,
        modifiedByUser: null,
        pregnancy: {
            id: undefined,
            lastPeriodDate: "",
            firstUltrasoundDate: "",
            ultrasound: {
                days: "",
                week: ""
            },
            gestationalAgeFUR: "",
            gestationalTrimesterFUR: "",
            gestationalTrimesterUltrasound: "",
            posibleChildbirthDateFUR: "",
            childbirthDateUltrasound: "",
            pregnancyIsHighRisk: false,
            complicationsInPregnancy: false,
            pregnancyComplications: [],
            typePregnancy: [],
            ectopicPregnancy: undefined,
            twinPregnancyB: undefined,
            additionalNotes: "",
            fetusesDetected: 0,
            twinPregnancy: {
                numberFetusesDetected: 0
            }
        },
        previousPregnancy: {
            id: undefined,
            childbirthDate: undefined,
            ectopicPregnancy: undefined,
            twinPregnancyB: undefined,
            complicationsInPregnancy: false,
            pregnancyComplications: [],
            additionalNotes: "",
            typePregnancies: [],
            childbirthComments: "",
            status: undefined,
            isEctopic: false,
            fetusesDetected: 0,
            twinPregnancy: {
                numberFetusesDetected: 0
            }
        },
        systemCreatedAt: "",
        systemUpdatedAt: "",
        systemCreatedAtEpochSecond: 0,
        status: ""
    } as PregnancyResponseI,
    reducers: {
        setPregnancyResponse: (state, action: PayloadAction<PregnancyResponseI>) => {
            state.id = action.payload.id;
            state.performedByUser = action.payload.performedByUser;
            state.modifiedByUser = action.payload.modifiedByUser;  
            state.pregnancy = action.payload.pregnancy; 
            state.previousPregnancy = action.payload.previousPregnancy; 
            state.systemCreatedAt = action.payload.systemCreatedAt; 
            state.systemUpdatedAt = action.payload.systemUpdatedAt; 
            state.systemCreatedAtEpochSecond = action.payload.systemCreatedAtEpochSecond; 
            state.status = action.payload.status; 
        },
        setPregnancyResponseId: (state, action: PayloadAction<string>) => {
            state.id = action.payload;
        },
        setPerformedByUser: (state, action: PayloadAction<PerformedPregnancyUser | null>) => {
            state.performedByUser = action.payload;
        },
        setModifiedByUser: (state, action: PayloadAction<PerformedPregnancyUser | null>) => {
            state.modifiedByUser = action.payload;
        },
        setPregnancy: (state, action: PayloadAction<ActualPregnancyI>) => {
            state.pregnancy = action.payload;
        },
        setPreviousPregnancy: (state, action: PayloadAction<PreviousPregnancyI>) => {
            state.previousPregnancy = action.payload;
        },
        setSystemCreatedAt: (state, action: PayloadAction<string>) => {
            state.systemCreatedAt = action.payload;
        },
        setSystemUpdatedAt: (state, action: PayloadAction<string>) => {
            state.systemUpdatedAt = action.payload;
        },
        setSystemCreatedAtEpochSecond: (state, action: PayloadAction<number>) => {
            state.systemCreatedAtEpochSecond = action.payload;
        },
        setStatus: (state, action: PayloadAction<string>) => {
            state.status = action.payload;
        },
        cleanPregnancy: (state) => {
            state.id = "";
            state.performedByUser = null;
            state.modifiedByUser = null;
            state.pregnancy = {
                id: undefined,
                lastPeriodDate: "",
                firstUltrasoundDate: "",
                ultrasound: {
                    days: "",
                    week: ""
                },
                gestationalAgeFUR: "",
                gestationalTrimesterFUR: "",
                gestationalTrimesterUltrasound: "",
                posibleChildbirthDateFUR: "",
                childbirthDateUltrasound: "",
                pregnancyIsHighRisk: false,
                complicationsInPregnancy: false,
                pregnancyComplications: [],
                typePregnancy: [],
                ectopicPregnancy: undefined,
                twinPregnancyB: undefined,
                additionalNotes: "",
                twinPregnancy: {
                    numberFetusesDetected: 0
                }
            };
            state.previousPregnancy = {
                id: undefined,
                childbirthDate: undefined,
                ectopicPregnancy: undefined,
                twinPregnancyB: undefined,
                complicationsInPregnancy: false,
                pregnancyComplications: [],
                additionalNotes: "",
                typePregnancies: [],
                childbirthComments: "",
                status: undefined,
                isEctopic: false,
                twinPregnancy: {
                    numberFetusesDetected: 0
                }
            };
            state.systemCreatedAt = "";
            state.systemUpdatedAt = "";
            state.systemCreatedAtEpochSecond = 0;
            state.status = "";
        },
    },
});

export const { 
    setPregnancyResponse,
    setPregnancyResponseId,
    setPerformedByUser,
    setModifiedByUser,
    setPregnancy,
    setPreviousPregnancy,
    setSystemCreatedAt,
    setSystemUpdatedAt,
    setSystemCreatedAtEpochSecond,
    setStatus,
    cleanPregnancy
    } = newPregnancySlice.actions;
export default newPregnancySlice.reducer;
